module.exports = __webpack_public_path__ + "static/media/live.522202a8.svg";